import React, { useContext, useState, useEffect } from "react";
import FetchingFreq from '../../contexts/FetchingFreq';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VariableContext from '../../contexts/VariableContext';
import TableComponent from '../../elments/TableComponent';
import CommonButton from "../../elments/CommonButton";

import { 
  faFolder, 
  faFile,
  faTable, 
  faChartBar,
  faArrowLeft,
  faGear,
  faDownload,
  faGauge,
  faBuilding,
  faWeightScale,
  faPeopleRoof,faUpload,
  faHouse,
  faLaptopFile,
  faChargingStation,
  faEdit,
  faSearch,
  faFilter,
  faSave,
  faRefresh,
  faExclamationTriangle,
  faFileExcel,
  faChevronDown,
  faCheckCircle,
  faArrowUp,
  faArrowDown,
  faSortNumericUp,
  faSortNumericDown,
  faRankingStar
} from '@fortawesome/free-solid-svg-icons';

const ScriptingPage = ({handleQuestionLogicChange,getCurrentLogic,setEditedValues,handleExportDimensionSyntax,handleExportSpssSyntax,handleSaveScriptingLogic}) => {
    const { 
        dataGroup, 
        setdataGroup, 
        selectedVariables, 
        banners, 
        setBanners, 
        setSelectedVariables, 
        projectId, 
        savedWeightings, 
        saveCurrentWeighting, 
        currentSelectedVariablesset, 
        setcurrentSelectedVariablesset, 
        setSavedWeightings, 
        weightedCounts, 
        weightingStats, 
        setWeightingStats, 
        setWeightedCounts, 
        targetPercentages, 
        setTargetPercentages, 
        currentSelectedVariables, 
        setCurrentSelectedVariables, 
        frequencyData, 
        setFrequencyData, 
        setSelectedClient, 
        setSelectedProject, 
        selectedProject, 
        selectedClient 
    } = useContext(VariableContext);

    const {
        setMessage, 
        setActivePage,
        handleTitleClick,
        selectedTitle, 
        setSelectedTitle,
        refreshData, 
        setRefreshData,
        selectedBanner, 
        setselectedBanner,
        selectedWeights, 
        setSelectedWeights,
        selectedVariable, 
        setSelectedVariable,
        loading, 
        setLoading,
        validationData, 
        setValidationData,
        handleDVValidation ,
        activeTab, setActiveTab
    } = useContext(FetchingFreq);

    const [activeSubTab, setActiveSubTab] = useState('Value Labels');
    const [cascadeLogicInput, setCascadeLogicInput] = useState('');
    const [rankingMin, setRankingMin] = useState('');
    const [rankingMax, setRankingMax] = useState('');
    const [straightLinerType, setStraightLinerType] = useState('std');
    const [straightLinerValue, setStraightLinerValue] = useState('');

    // Initialize values from selectedVariable
    useEffect(() => {
        if (selectedVariable?.rankingCheck) {
            setRankingMin(selectedVariable.rankingCheck.min?.toString() || '');
            setRankingMax(selectedVariable.rankingCheck.max?.toString() || '');
        } else {
            setRankingMin('');
            setRankingMax('');
        }

        if (selectedVariable?.straightLinerType) {
            setStraightLinerType(selectedVariable.straightLinerType);
        }

        if (selectedVariable?.straightLinerValue) {
            setStraightLinerValue(selectedVariable.straightLinerValue.toString());
        }
    }, [selectedVariable]);

    const extractVariableRefs = (text) => {
      if (!text) return [];

      return text
        .split(/[\s(),]+/)
        .map(t => t.trim())
        .filter(Boolean)
        .filter(t => !['and', 'or', 'not'].includes(t.toLowerCase()));
    };

    const parseCascadeExpression = (text) => {
      return text
        .split(/\bor\b/i)
        .map(part => part.trim())
        .map(expr => {
          const [varName, condition] = expr.split('=').map(s => s.trim());
          return {
            varName,
            condition: condition || null
          };
        });
    };
    
    const resolveRowVariable = (variable, rowIndex) => {
      if (!variable?.varName) return null;

      const match = variable.varName.find(
        v => String(v.row) === String(rowIndex)
      );

      return match?.Name || null;
    };

    const findVariableFromDataGroup = (varName) => {
      if (!dataGroup) return null;
      return dataGroup[varName] || null;
    };

    const getVariableValues = (variable) => {
      if (!variable) return [];

      if (Array.isArray(variable.values) && variable.values.length) {
        return variable.values;
      }

      if (Array.isArray(variable.Rows) && variable.Rows.length) {
        return variable.Rows.map(r => ({
          index: Number(r.index),
          title: r.title || r.text
        }));
      }

      return [];
    };

    const getCascadeTarget = () => {
      if (!isGridType(selectedVariable?.type)) return 'values';

      if (activeSubTab === 'Rows' && selectedVariable?.Rows?.length) {
        return 'rows';
      }

      return 'values';
    };

    const getTargetItems = (variable, target) => {
      return target === 'rows' ? variable.Rows || [] : variable.values || [];
    };

    const handleMatchCascading = () => {
      if (!cascadeLogicInput.trim()) {
        alert("Please enter cascading logic");
        return;
      }

      const targetType = getCascadeTarget();
      const targetItems = getTargetItems(selectedVariable, targetType);

      if (!targetItems.length) {
        alert(`No ${targetType} available to apply cascading`);
        return;
      }

      const expressions = parseCascadeExpression(cascadeLogicInput);
      const valueLogicMap = {};

      expressions.forEach(expr => {
        const hasCondition = Boolean(expr.condition);

        const baseVarName = hasCondition
          ? expr.varName.replace(/r\d+$/i, '')
          : expr.varName;

        const sourceVar = validationData?.[baseVarName] || null;

        targetItems.forEach(item => {
          const idx = Number(item.index);
          if (!valueLogicMap[idx]) valueLogicMap[idx] = [];

          // ✅ Row-based resolution ONLY when "=" exists
          if (hasCondition && sourceVar?.varName?.length) {
            const physicalVar = resolveRowVariable(sourceVar, idx);
            if (physicalVar) {
              valueLogicMap[idx].push(`${physicalVar}=${expr.condition}`);
            }
          } 
          // ✅ Normal cascading
          else {
            valueLogicMap[idx].push(`${expr.varName}=${idx}`);
          }
        });
      });

      // ✅ Apply logic to correct target
      setSelectedVariable(prev => {
        if (!prev) return prev;

        const updated = { ...prev };
        const listKey = targetType === 'rows' ? 'Rows' : 'values';

        updated[listKey] = updated[listKey].map(item => {
          const cascade = valueLogicMap[item.index]?.join(' OR ');
          if (!cascade) return item;

          return {
            ...item,
            filterLogic: item.filterLogic
              ? `(${item.filterLogic}) AND (${cascade})`
              : cascade
          };
        });

        return updated;
      });

      // ✅ Persist edits correctly
      setEditedValues(prev => {
        const updated = { ...(prev || {}) };
        const listKey = targetType === 'rows' ? 'row' : 'value';

        targetItems.forEach((item, i) => {
          if (valueLogicMap[item.index]) {
            updated[selectedTitle] = {
              ...(updated[selectedTitle] || {}),
              [`${listKey}-${i}`]: valueLogicMap[item.index].join(' OR ')
            };
          }
        });

        return updated;
      });
    };

    const isStraightLinerApplicable = (type) => {
      return ['Single2DGrid', 'Single3DGrid', 'Single4DGrid'].includes(type);
    };

    const handleQuestionTermLogicChange = (newLogic) => {
      setSelectedVariable(prev => ({ ...prev, termLogic: newLogic }));
    };

    const isResponseType = (type) => {
      return ['Single Response'].includes(type);
    };

    const hasCols = selectedVariable && selectedVariable.Cols && selectedVariable.Cols.length > 0;
    const hasRows = selectedVariable && selectedVariable.Rows && selectedVariable.Rows.length > 0;
    const hasStatements = selectedVariable && selectedVariable.Statements && selectedVariable.Statements.length > 0;

    const handleHiddenChange = (checked) => {
      setSelectedVariable(prev => {
        if (!prev) return prev;
        return {
          ...prev,
          isHidden: checked
        };
      });
    };

    const isGridType = (type) => {
      return ['SingleGrid', 'MultiGrid', 'Multiple Response','Multiple2DGrid', 'NumericGrid', 'Single Grid', 'Single2DGrid', 'Numeric2DGrid', 'Single3DGrid', 'Multiple3DGrid', 'Numeric3DGrid', 'Single4DGrid', 'Numeric'].includes(type);
    };

    const isRankingApplicable = (type) => {
      return isGridType(type) || ['Single Response', 'Multiple Response', 'Numeric'].includes(type);
    };

    // Handle straight liner checkbox change
    const handleStraightLinerCheckChange = (checked) => {
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        if (checked) {
          return {
            ...prev,
            isStraightLinerCheck: true,
            straightLinerType: straightLinerType || 'std',
            straightLinerValue: straightLinerValue ? parseFloat(straightLinerValue) : undefined
          };
        } else {
          const updated = { ...prev };
          delete updated.isStraightLinerCheck;
          delete updated.straightLinerType;
          delete updated.straightLinerValue;
          return updated;
        }
      });
    };

    // Handle straight liner type change
    const handleStraightLinerTypeChange = (value) => {
      setStraightLinerType(value);
      
      if (selectedVariable?.isStraightLinerCheck) {
        setSelectedVariable(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            straightLinerType: value
          };
        });
      }
    };

    // Handle straight liner value change
    const handleStraightLinerValueChange = (value) => {
      setStraightLinerValue(value);
      
      if (selectedVariable?.isStraightLinerCheck) {
        setSelectedVariable(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            straightLinerValue: value ? parseFloat(value) : undefined
          };
        });
      }
    };

    // Handle ranking checkbox change
    const handleRankingCheckChange = (checked) => {
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        if (checked) {
          return {
            ...prev,
            rankingCheck: {
              enabled: true,
              min: rankingMin ? parseInt(rankingMin) : undefined,
              max: rankingMax ? parseInt(rankingMax) : undefined
            }
          };
        } else {
          const { rankingCheck, ...rest } = prev;
          return rest;
        }
      });
    };

    // Handle ranking min/max changes
    const handleRankingMinChange = (value) => {
      setRankingMin(value);
      
      if (selectedVariable?.rankingCheck?.enabled) {
        setSelectedVariable(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            rankingCheck: {
              ...prev.rankingCheck,
              min: value ? parseInt(value) : undefined
            }
          };
        });
      }
    };

    const handleRankingMaxChange = (value) => {
      setRankingMax(value);
      
      if (selectedVariable?.rankingCheck?.enabled) {
        setSelectedVariable(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            rankingCheck: {
              ...prev.rankingCheck,
              max: value ? parseInt(value) : undefined
            }
          };
        });
      }
    };

    // Helper functions for property updates
    const handlePropertyChange = (property, itemType, index, value) => {
      if (!selectedTitle || !selectedVariable) return;
      
      setEditedValues(prev => ({
        ...prev,
        [selectedTitle]: {
          ...(prev[selectedTitle] || {}),
          [`${itemType}-${index}-${property}`]: value
        }
      }));
      
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        const updated = { ...prev };
        let items;
        let itemKey;
        
        switch(itemType) {
          case 'value':
            items = updated.values;
            itemKey = 'values';
            break;
          case 'row':
            items = updated.Rows;
            itemKey = 'Rows';
            break;
          case 'col':
            items = updated.Cols;
            itemKey = 'Cols';
            break;
          case 'stmt':
            items = updated.Statements;
            itemKey = 'Statements';
            break;
          default:
            return prev;
        }
        
        if (items && items[index]) {
          items[index] = {
            ...items[index],
            [property]: value
          };
        }
        
        return updated;
      });
    };

    const renderStatements = (variable) => {
      return (
        <TableComponent
          title="Statements"
          items={variable.Statements || []}
          itemType="stmt"
          getCurrentLogic={getCurrentLogic}
          handleLogicChange={(index, newLogic) => handleStatementLogicChange(index, newLogic)}
          handlePropertyChange={handlePropertyChange}
          isGridType={isGridType}
        />
      );
    };

    const handleStatementLogicChange = (stmtIndex, newLogic) => {
      if (!selectedTitle) return;
      
      setEditedValues(prev => ({
        ...prev,
        [selectedTitle]: {
          ...(prev[selectedTitle] || {}),
          [`stmt-${stmtIndex}`]: newLogic
        }
      }));
      
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        const updated = { ...prev };
        if (updated.Statements && updated.Statements[stmtIndex]) {
          updated.Statements[stmtIndex] = {
            ...updated.Statements[stmtIndex],
            filterLogic: newLogic
          };
        }
        return updated;
      });
    };

    const renderValues = (variable) => {
      return (
        <TableComponent
          title="Values"
          items={variable.values || []}
          itemType="value"
          getCurrentLogic={() => ''}
          handleLogicChange={(index, newLogic) => handleValueLogicChange(index, newLogic)}
          handlePropertyChange={handlePropertyChange}
          isGridType={isGridType}
        />
      );
    };

    const renderRows = (variable) => {
      return (
        <TableComponent
          title="Rows"
          items={variable.Rows || []}
          itemType="row"
          getCurrentLogic={() => ''}
          handleLogicChange={(index, newLogic) => handleRowLogicChange(index, newLogic)}
          handlePropertyChange={handlePropertyChange}
          isGridType={isGridType}
        />
      );
    };

    const renderCols = (variable) => {
      return (
        <TableComponent
          title="Columns"
          items={variable.Cols || []}
          itemType="col"
          getCurrentLogic={getCurrentLogic}
          handleLogicChange={(index, newLogic) => handleColLogicChange(index, newLogic)}
          handlePropertyChange={handlePropertyChange}
          isGridType={isGridType}
        />
      );
    };

    const handleValueLogicChange = (valueIndex, newLogic) => {
      if (!selectedTitle) return;
      
      setEditedValues(prev => ({
        ...prev,
        [selectedTitle]: {
          ...(prev[selectedTitle] || {}),
          [`value-${valueIndex}`]: newLogic
        }
      }));
      
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        const updated = { ...prev };
        if (updated.values && updated.values[valueIndex]) {
          updated.values[valueIndex] = {
            ...updated.values[valueIndex],
            filterLogic: newLogic
          };
        }
        return updated;
      });
    };

    const handleRowLogicChange = (rowIndex, newLogic) => {
      if (!selectedTitle) return;
      
      setEditedValues(prev => ({
        ...prev,
        [selectedTitle]: {
          ...(prev[selectedTitle] || {}),
          [`row-${rowIndex}`]: newLogic
        }
      }));
      
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        const updated = { ...prev };
        if (updated.Rows && updated.Rows[rowIndex]) {
          updated.Rows[rowIndex] = {
            ...updated.Rows[rowIndex],
            filterLogic: newLogic
          };
        }
        return updated;
      });
    };

    const handleColLogicChange = (colIndex, newLogic) => {
      if (!selectedTitle) return;
      
      setEditedValues(prev => ({
        ...prev,
        [selectedTitle]: {
          ...(prev[selectedTitle] || {}),
          [`col-${colIndex}`]: newLogic
        }
      }));
      
      setSelectedVariable(prev => {
        if (!prev) return prev;
        
        const updated = { ...prev };
        if (updated.Cols && updated.Cols[colIndex]) {
          updated.Cols[colIndex] = {
            ...updated.Cols[colIndex],
            filterLogic: newLogic
          };
        }
        return updated;
      });
    };

    // Straight Liner Check Section
    const renderStraightLinerCheck = () => {
      if (!isStraightLinerApplicable(selectedVariable?.type)) return null;

      return (
        <div className="straight-liner-section" style={{
          marginTop: '15px',
          padding: '15px',
          border: '1px solid #e0e0e0',
          borderRadius: '6px',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '500', fontSize: '14px' }}>
              <input
                type="checkbox"
                checked={selectedVariable?.isStraightLinerCheck || false}
                onChange={(e) => handleStraightLinerCheckChange(e.target.checked)}
                style={{ width: '16px', height: '16px' }}
              />
              <FontAwesomeIcon icon={faWeightScale} style={{ color: '#667eea' }} />
              Apply Straight-liner Check
            </label>
          </div>
          
          {selectedVariable?.isStraightLinerCheck && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: '#666' }}>
                  Detection Type:
                </label>
                <select
                  value={straightLinerType}
                  onChange={(e) => handleStraightLinerTypeChange(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                >
                  <option value="std">Standard Deviation</option>
                  <option value="count">Count-based</option>
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: '#666' }}>
                  {straightLinerType === 'std' ? 'Max Standard Deviation:' : 'Min Count:'}
                </label>
                <input
                  type="number"
                  value={straightLinerValue}
                  onChange={(e) => handleStraightLinerValueChange(e.target.value)}
                  placeholder={straightLinerType === 'std' ? 'e.g., 0.8' : 'e.g., 10'}
                  step={straightLinerType === 'std' ? '0.1' : '1'}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
          )}
          
          <div style={{ fontSize: '11px', color: '#888', marginTop: '8px' }}>
            <p>
              {straightLinerType === 'std' 
                ? 'Lower std deviation indicates more consistent/straight-line responses'
                : 'Higher count indicates more consistent selection patterns'
              }
            </p>
          </div>
        </div>
      );
    };

    // Ranking Check Section
    const renderRankingCheck = () => {
      if (!isRankingApplicable(selectedVariable?.type)) return null;

      return (
        <div className="ranking-check-section" style={{
          marginTop: '15px',
          padding: '15px',
          border: '1px solid #e0e0e0',
          borderRadius: '6px',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '500', fontSize: '14px' }}>
              <input
                type="checkbox"
                checked={selectedVariable?.rankingCheck?.enabled || false}
                onChange={(e) => handleRankingCheckChange(e.target.checked)}
                style={{ width: '16px', height: '16px' }}
              />
              <FontAwesomeIcon icon={faRankingStar} style={{ color: '#667eea' }} />
              Apply Ranking Check
            </label>
          </div>
          
          {selectedVariable?.rankingCheck?.enabled && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: '#666' }}>
                  Min Rank:
                </label>
                <input
                  type="number"
                  value={rankingMin}
                  onChange={(e) => handleRankingMinChange(e.target.value)}
                  placeholder="Minimum"
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                />
              </div>
              
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', color: '#666' }}>
                  Max Rank:
                </label>
                <input
                  type="number"
                  value={rankingMax}
                  onChange={(e) => handleRankingMaxChange(e.target.value)}
                  placeholder="Maximum"
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
          )}
          
          <div style={{ fontSize: '11px', color: '#888', marginTop: '8px' }}>
            <p>Set minimum and maximum allowed values for validation</p>
          </div>
        </div>
      );
    };

    return (
      <div className="scripting-content">
        <div className="scripting-main">
          {selectedVariable ? (
            <div className="variable-details">
              <div className="question-header" style={{ 
                padding: '20px', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                color: 'white',
                borderRadius: '8px',
                marginBottom: '20px'
              }}>
                <h4>{selectedVariable.Qtitle}</h4>
                <p><strong>Type:</strong> {selectedVariable.type}</p>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                  <input
                    type="checkbox"
                    checked={selectedVariable?.isHidden || false}
                    onChange={(e) => handleHiddenChange(e.target.checked)}
                    style={{ width: '16px', height: '16px' }}
                  />
                  <span>Hidden in scripting</span>
                </label>
              </div>
              
              {/* Straight Liner Check Section */}
              {renderStraightLinerCheck()}
              
              {/* Ranking Check Section */}
              {renderRankingCheck()}
              
              <div className="filter-logic-section" style={{
                padding: '20px',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                backgroundColor: 'white',
                marginBottom: '20px'
              }}>
                <h4 className="filter-logic-header" style={{ marginTop: 0, marginBottom: '10px' }}>Filter Logic</h4>
                <input
                  type="text"
                  placeholder="e.g. Q1 == 1 and Q3 != 5"
                  value={selectedVariable.Logic || ''}
                  onChange={(e) => handleQuestionLogicChange(e.target.value)}
                  className="filter-logic-input"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px',
                    marginBottom: '15px'
                  }}
                />

                <h4 className="filter-logic-header" style={{ marginBottom: '10px' }}>Termination Logic</h4>
                <input
                  type="text"
                  placeholder="e.g. Q1 == 1 and Q3 != 5"
                  value={selectedVariable.termLogic || ''}
                  onChange={(e) => handleQuestionTermLogicChange(e.target.value)}
                  className="filter-logic-input"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    fontSize: '14px',
                    marginBottom: '15px'
                  }}
                />
                
                <div className="cascade-logic-section" style={{ marginTop: '15px' }}>
                  <h4 className="filter-logic-header" style={{ marginBottom: '10px' }}>
                    Cascading / Piping Logic
                  </h4>

                  <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                    <input
                      type="text"
                      placeholder="e.g. Q4 or Q5"
                      value={cascadeLogicInput}
                      onChange={(e) => setCascadeLogicInput(e.target.value)}
                      className="filter-logic-input"
                      style={{
                        flex: 1,
                        padding: '10px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '14px'
                      }}
                    />

                    <CommonButton
                      title="Match cascading logic to all values"
                      onClick={handleMatchCascading}
                      variant="success"
                      symbol={faCheckCircle}
                      label="Match Cascading"
                      size="large"
                    />
                  </div>
                </div>

                <small style={{ color: '#666', display: 'block', marginTop: '8px' }}>
                  Automatically maps values by index and applies logic to each value
                </small>
              </div>

              {isGridType(selectedVariable.type) && (
                <div className="sub-tabs" style={{ display: 'flex', gap: '5px', marginBottom: '15px', flexWrap: 'wrap' }}>
                  {hasCols && (
                    <CommonButton
                      title="Configure column logic"
                      onClick={() => setActiveSubTab('Columns')}
                      variant={activeSubTab === 'Columns' ? "primary" : "tab"}
                      isSelected={activeSubTab === 'Columns'}
                      label="Columns"
                      size="small"
                    />
                  )}
                  {hasRows && (
                    <CommonButton
                      title="Configure row logic"
                      onClick={() => setActiveSubTab('Rows')}
                      variant={activeSubTab === 'Rows' ? "primary" : "tab"}
                      isSelected={activeSubTab === 'Rows'}
                      label="Rows"
                      size="small"
                    />
                  )}
                  {hasStatements && (
                    <CommonButton
                      title="Configure statement logic"
                      onClick={() => setActiveSubTab('Statements')}
                      variant={activeSubTab === 'Statements' ? "primary" : "tab"}
                      isSelected={activeSubTab === 'Statements'}
                      label="Statements"
                      size="small"
                    />
                  )}
                  <CommonButton
                    title="Configure value logic"
                    onClick={() => setActiveSubTab('Values')}
                    variant={activeSubTab === 'Values' ? "primary" : "tab"}
                    isSelected={activeSubTab === 'Values'}
                    label="Values"
                    size="small"
                  />
                </div>
              )}
              
              <div className="sub-tab-content">
                {isResponseType(selectedVariable.type) || !isGridType(selectedVariable.type) ? (
                  renderValues(selectedVariable)
                ) : isGridType(selectedVariable.type) ? (
                  activeSubTab === 'Columns' && hasCols 
                    ? renderCols(selectedVariable)
                    : activeSubTab === 'Rows' && hasRows
                      ? renderRows(selectedVariable)
                      : activeSubTab === 'Statements' && hasStatements
                        ? renderStatements(selectedVariable)
                        : activeSubTab === 'Values'
                          ? renderValues(selectedVariable)
                          : <p>No content for selected tab.</p>
                ) : (
                  <p>Details for this variable type are not yet implemented.</p>
                )}
              </div>

              {/* Export Buttons Section */}
              <div className="export-section" style={{ 
                display: 'flex', 
                gap: '10px', 
                flexWrap: 'wrap', 
                marginTop: '20px',
                padding: '20px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '8px'
              }}>
                <CommonButton
                  title="Export SPSS syntax file"
                  onClick={handleExportSpssSyntax}
                  disabled={loading}
                  variant="success"
                  symbol={faDownload}
                  label="Export SPSS Syntax (.sps)"
                  size="large"
                />

                <CommonButton
                  title="Export Dimension syntax file"
                  onClick={handleExportDimensionSyntax}
                  disabled={loading}
                  variant="primary"
                  symbol={faDownload}
                  label="Export Dimension Syntax (.mrs)"
                  size="large"
                />

                <CommonButton
                  title="Save all scripting settings"
                  onClick={handleSaveScriptingLogic}
                  variant="warning"
                  symbol={faSave}
                  label="Save All Settings"
                  size="large"
                />
              </div>
            </div>
          ) : (
            <div className="no-selection-message" style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              <p>Select a variable to view scripting details.</p>
            </div>
          )}
        </div>

      </div>
    );
};

export default ScriptingPage;